import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { QA_NAME_RESET_BTN, QA_NAME_SUBMIT_BTN } from '../../../constants/qa'
import Button from '../../Button'

import * as styles from './SettingSectionButtons.module.css'

function SettingSectionButtons({
  ButtonReset = Button.Outlined,
  ButtonSave = Button.Contained,
  Container = 'div',
  children,
  className = styles.SettingSectionButtons,
  resetProps: {
    text: resetBtnText = 'Common.ResetBtnKey',
    ...resetProps
  } = EMPTY_OBJECT,
  saveProps: {
    text: saveBtnText = 'Common.SaveChangesBtnKey',
    ...saveProps
  } = EMPTY_OBJECT,
}) {
  const { t } = useTranslation()

  return (
    <Container className={className}>
      {ButtonReset ? (
        <ButtonReset
          {...resetProps}
          qaName={QA_NAME_RESET_BTN}
          text={t(resetBtnText)}
        />
      ) : null}
      {ButtonSave ? (
        <ButtonSave
          {...saveProps}
          qaName={QA_NAME_SUBMIT_BTN}
          text={t(saveBtnText)}
        />
      ) : null}
      {children}
    </Container>
  )
}

export default SettingSectionButtons
